import {useCallback, useState} from 'react';

export function useBooleanState(initialValue: boolean) {
	const [value, setValue] = useState(initialValue);

	const handleSetTrue = useCallback(() => setValue(true), []);
	const handleSetFalse = useCallback(() => setValue(false), []);

	return [value, handleSetTrue, handleSetFalse, setValue] as const;
}

useBooleanState.displayName = 'useBooleanState';
